import * as rs from "random-seed";

let rand = rs.create();
const randomInt = (n) => rand.intBetween(0, n-1);
const pickRandom = (choices) => choices[rand.intBetween(0, choices.length - 1)];

const rangeN = (n) => {
    let vals = [];
    for(let i=0; i<n; i++){
        vals.push(i);
    }
    return vals;
};

const counterN = (n) => {
    let counter = [];
    for(let i=0; i<n; i++){
        counter.push(0);
    }
    return counter;
};

const remaining = (listOfRemovalLists, n) => {
    let start = rangeN(n);
    for (let list of listOfRemovalLists) {
        for (let el of list) {
            let idx = start.indexOf(el);
            if(idx != -1) {
                start.splice(idx, 1);
            }
        }
    }
    return start;
};

const generateRow = (existingRows, n) => {
    /*
    Work along row, generating each square in turn
     */
    let newRow = [];
    for(let i=0; i<n; i++){

        let inCol = [];
        for(let j=0; j<existingRows.length; j++){
            inCol.push(existingRows[j][i]);
        }
        let available = remaining([newRow, inCol], n);

        if(available.length > 0){
            newRow.push(pickRandom(available));
        } else {
            return null;
        }
    }
    return newRow;
};

const generateLatinSquare = (n) => {
    let rows = [];
    let count = 0; //probably being paranoid but I'd have to actually do more Maths to figure out if necessary
    for(let i=0; i<n; i++){
        let newRow;
        while (!newRow && count < 100) {
            newRow = generateRow(rows, n);
            count++;
        }

        if(!!newRow){
            rows.push(newRow);
        } else {
            i--; //ha! this awful but as first row should always be generated fine should be okay
        }
    }
    return rows;
};

const deepCopy = (obj) => JSON.parse(JSON.stringify(obj));

const removeClue = (puzzle, n) => {
    let newPuzzle = deepCopy(puzzle);
    const removeId = randomInt(n*4);
    if(removeId < n){
        newPuzzle.rows[0][removeId].colour = -1;
        newPuzzle.rows[0][removeId].answer = -1;
    }else if(removeId < 2*n){
        newPuzzle.rows[n+1][removeId - n].colour = -1;
        newPuzzle.rows[n+1][removeId - n].answer = -1;
    }else if(removeId < 3*n){
        newPuzzle.rows[removeId - 2*n][0].colour = -1;
        newPuzzle.rows[removeId - 2*n][0].answer = -1;
    }else{
        newPuzzle.rows[removeId - 3*n][n+1].colour = -1;
        newPuzzle.rows[removeId - 3*n][n+1].answer = -1;
    }
    return newPuzzle;
};


const generatePuzzleWithDifficulty = (n, m, d) => {
    const ls = generateLatinSquare(n);
    const count = n + 2;

    const startIdx = 0;
    const endIdx = count - 1;

    const genItem = (i,j) => {
        let colour;
        if(ls[i-1][j-1] < m){
            colour = ls[i-1][j-1] + 1;
        } else {
            colour = 0;
        }

        return {
            x: j,
            y: i,
            interactive:true,
            colour: 0,
            answer: colour
        }
    };

    const genClue = (i,j) => {
        let colour;
        if(j == startIdx) {
            let row = ls[i-1];
            for(let k=0; k<row.length; k++){
                if(row[k] < m){
                    colour = row[k] + 1;
                    break;
                }
            }
        } else if(j == endIdx) {
            let row = ls[i-1];
            for(let k=row.length - 1; k>0; k--){
                if(row[k] < m){
                    colour = row[k] + 1;
                    break;
                }
            }
        } else if(i == startIdx) {
            for(let k=0; k<n; k++){
                if(ls[k][j-1] < m){
                    colour = ls[k][j-1] + 1;
                    break;
                }
            }
        } else if(i == endIdx) {
            for(let k=n-1; k>0; k--){
                if(ls[k][j-1] < m){
                    colour = ls[k][j-1] + 1;
                    break;
                }
            }
        }
        return {
            x: j,
            y: i,
            interactive:false,
            colour: colour,
            answer: colour
        }
    };

    const genEmpty = (i,j) => { return {x:j, y:i, interactive:false, colour:-1, answer:-1}};


    var rows = [];
    for(let i=0; i<count; i++){
        let row = [];
        for(let j=0; j<count; j++){
            if(i == startIdx  && j == startIdx ||
                i == endIdx && j == startIdx ||
                j == endIdx  && i == endIdx||
                j == endIdx && i == startIdx) {
                row.push(genEmpty(i,j));
            } else if(i == startIdx || i == endIdx || j == startIdx || j == endIdx){
                row.push(genClue(i,j));
            } else {
                row.push(genItem(i,j));
            }
        }
        rows.push(row);
    }

    let puzzle = {rows};
    for(let i=0; i<d; i++){
        puzzle = removeClue(puzzle, n);
    }

    console.log(puzzle.rows);

    //Make 6x6+ puzzles actually interesting (hopefully!)
    if(n >= 6) {
        for(let i=2; i< n; i++){
            for(let j=2; j< n; j++){
                if(puzzle.rows[i][j].answer == 0){
                    puzzle.rows[i][j].interactive = false;
                    puzzle.rows[i][j].colour = -1;
                    puzzle.rows[i][j].answer = -1;
                }
            }
        }
    }

    console.log(puzzle.rows);

    return puzzle;
};

const isSolution = (puzzle, n, m) => {
    //console.log("Is solution?", puzzle);
    //1. easy check (one of each in row and columns):
    const isRowValid = (i) => {
        let counter = counterN(m+1);
        for(let j=1; j<n+1; j++){
            counter[puzzle.rows[i][j].colour] += 1;
        }
        for(let a=1; a<=m; a++){
            if(counter[a] != 1) return false;
        }
        return true;
    };

    const isColValid = (j) => {
        let counter = counterN(m+1);
        for(let i=1; i<n+1; i++){
            counter[puzzle.rows[i][j].colour] += 1;
        }
        for(let a=1; a<=m; a++){
            if(counter[a] != 1) return false;
        }
        return true;
    };

    for(let r=1; r< n+1; r++){
        if(!isRowValid(r)){
            return false;
        }
    }
    for(let c=1; c< n+1; c++){
        if(!isColValid(c)){
            return false;
        }
    }
    //2. now clues:

    for(let cid=0; cid<4*n; cid++) {
        if(cid < n){
            let i = cid;
            if(puzzle.rows[i][0].colour != -1)
                for(let j=1; j <= n; j++){
                    let c = puzzle.rows[i][j].colour;
                    if(c > 0) {
                        if(c!= puzzle.rows[i][0].colour)
                            return false; //look for first colour in row,
                        break; //otherwise break out of this loop
                    }
                }
        }else if(cid < 2*n){
            let i = cid- n;
            if(puzzle.rows[i][n+1].colour != -1)
                for(let j=n; j >= 1 ; j--){
                    let c = puzzle.rows[i][j].colour;
                    if(c > 0) {
                        if(c!= puzzle.rows[i][n+1].colour)
                            return false; //look for first colour in row (backwards),
                        break; //otherwise break out of this loop
                    }
                }
        }else if(cid < 3*n){
            let j = cid - 2*n;
            if(puzzle.rows[0][j].colour != -1)
                for(let i=1; i <= n; i++){
                    let c = puzzle.rows[i][j].colour;
                    if(c > 0) {
                        if(c!= puzzle.rows[0][j].colour)
                            return false; //look for first colour in row,
                        break; //otherwise break out of this loop
                    }
                }
        }else {
            let j = cid - 3*n;
            if(puzzle.rows[n+1][j].colour != -1)
                for(let i=n; i >= 1; i--){
                    let c = puzzle.rows[i][j].colour;
                    if(c > 0) {
                        if(c!= puzzle.rows[n+1][j].colour)
                            return false; //look for first colour in row,
                        break; //otherwise break out of this loop
                    }
                }
        }

    }
    return true;
};

const puzzle = {
    setSeed(seed){
      rand = rs.create(seed);
    },
    isSolution,
    generatePuzzle: generatePuzzleWithDifficulty,
    generateFakePuzzle(){
        const size = 5;
        const count = size + 2;

        const startIdx = 0;
        const endIdx = count - 1;

        const genItem = (i,j) => {
            return {
                x:j,
                y:i,
                interactive:true,
                colour: 0,
                answer: randomInt(4)
            }
        };

        const genClue = (i,j) => {
            let answer = randomInt(4);
            if(answer === 0) answer = -1;
            return {
                x:j,
                y:i,
                interactive:false,
                colour: answer,
                answer
            }
        };

        var rows = [];
        for(let i=0; i<count; i++){
            let row = [];
            for(let j=0; j<count; j++){
                if(i == startIdx  && j == startIdx ||
                    i == endIdx && j == startIdx ||
                    j == endIdx  && i == endIdx||
                    j == endIdx && i == startIdx) {
                    row.push({x:i, y:j, interactive:false, colour:-1, answer:-1});
                } else if(i == startIdx || i == endIdx || j == startIdx || j == endIdx){
                    row.push(genClue(i,j));
                } else {
                    row.push(genItem(i,j));
                }
            }
            rows.push(row);
        }
       return { rows }
    }
};

export default puzzle;


// WEBPACK FOOTER //
// ./src/components/rgb/lib/puzzle.js